import {CoreBase} from "@core/base/core-base";
import {WebChatSetting} from "@core/web/web-chat-setting/web-chat-setting";
import {WebChat} from "@core/web/web-chat/web-chat";
import {WebChatAction} from "@core/web/web-chat-action/web-chat-action";
import {WebSession} from "@core/web/web-session/web-session";
import { WebSubscription } from "@core/web/web-subscription/web-subscription";
import { Injectable } from "@angular/core";
import { ICoreDependencies } from "@core/core-boot/core-boot.types";
import { WebChatRepository } from "@core/web/web-chat-repository/web-chat-repository";
import { ChatUtilsService } from "@core/shared/chat-utils.service";
import { WebOffice } from "@core/web/web-office/web-office";

@Injectable({
    providedIn: 'root'
})
export class CoreWeb extends CoreBase implements CoreBase {
    constructor(
        public chatSetting: WebChatSetting,
        public chat: WebChat,
        public chatAction: WebChatAction,
        public session: WebSession,
        public subscription: WebSubscription,
        public chatUtils: ChatUtilsService,
        public office: WebOffice,
    ) {
        super();
    }

    static async bootstrap(dependencies: ICoreDependencies): Promise<CoreWeb> {
        const chatSetting = new WebChatSetting();
        const session = new WebSession(dependencies);
        const chatRepository = new WebChatRepository(dependencies.db);
        const chat = new WebChat(session, chatRepository, chatSetting);
        const chatAction = new WebChatAction(dependencies.clipboard);
        const subscription = new WebSubscription();
        const chatUtils = new ChatUtilsService()
        const office = new WebOffice()

        return new CoreWeb(
            chatSetting,
            chat,
            chatAction,
            session,
            subscription,
            chatUtils,
            office,
        )
    }
}
